import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface CircularProgressProps {
  size?: number;
  strokeWidth?: number;
  duration?: number;
  progress?: number;
  progressColor?: string;
  trailColor?: string;
  startAngle?: number;
  onFinish?: () => void;
  children?: React.ReactNode;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 120,
  strokeWidth = 10,
  duration = 5,
  progress,
  progressColor = "#8451D6",
  trailColor = "#e0e0e0",
  startAngle = -90,
  onFinish,
  children,
}) => {
  const [currentProgress, setCurrentProgress] = React.useState(0);
  
  // React.useEffect(() => {
  //   // If progress is provided externally, use that value
  //   if (progress !== undefined) {
  //     setCurrentProgress(progress);
  //     return;
  //   }
    
  //   // Auto progress animation
  //   const startTime = Date.now();
  //   let animationFrameId: number;
    
  //   const updateProgress = () => {
  //     const elapsed = (Date.now() - startTime) / 1000;
  //     const nextProgress = Math.min((elapsed / duration) * 100, 100);
      
  //     setCurrentProgress(nextProgress);
      
  //     if (nextProgress < 100) {
  //       animationFrameId = requestAnimationFrame(updateProgress);
  //     } else {
  //       onFinish?.();
  //     }
  //   };
    
  //   animationFrameId = requestAnimationFrame(updateProgress);
    
  //   return () => {
  //     cancelAnimationFrame(animationFrameId);
  //   };
  // }, [duration, onFinish, progress]);
  
  // Calculate the path rotation based on startAngle
  // react-circular-progressbar uses 0 at the top (12 o'clock) and rotates clockwise
  // Adjust by adding 90 degrees to make -90 the starting position (which is the top)
  const rotation = startAngle + 90;
  
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgressbar
        value={progress}
        strokeWidth={strokeWidth * 100 / size}
        styles={buildStyles({
          rotation: rotation / 360,
          strokeLinecap: "round",
          pathColor: progressColor,
          trailColor: trailColor,
          pathTransition: progress !== undefined ? "stroke-dashoffset 0.3s ease 0s" : "none",
          // When in auto mode, disable the built-in transition to use our own animation timing
        })}
      />

      <div
        style={{
          position: "absolute",
          //width: `calc(100% - ${strokeWidth * 2}px)`,
          aspectRatio:"1 / 1",
          height: `calc(100% - ${strokeWidth * 2}px)`,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CircularProgress;